import Cookies from 'js-cookie';
import { useRouter } from 'next/router';
import { getRouterLocale } from '../../Utils/i18Utils/constant';
import { getSearchParams } from '../Parenting/common';
import { getWebUserId } from '../../Utils/helper';

export const webUserId = Cookies.get('web_user_id_react') || null;
export const chatPopupQueryString = 'chatPopup';
export const callbackPopupString = 'callbackPopup';
export const bookingPopupQueryString = 'bookingPopup';
export const loginUserDetails = Cookies.get('react_user_properties') || null;
export const clinicListingFetcherParams = {
  Cache: true,
  userType: 'A',
  isForNewClinicPdp: true,
  random: new Date().getTime(),
};
export const pushAnotherRoute = (queryName, router) => {
  const params = new URLSearchParams(window.location.search);
  params.set(queryName, true);
  router.push(window?.location?.pathname + '?' + params, undefined, {
    shallow: true,
    scroll: false,
  });
};
export const getRequestCallParams = (
  clinicId,
  packageName,
  data,
  query_string,
) => {
  return {
    product_id: JSON.parse(clinicId),
    product_name: packageName,
    expert: 'true',
    mobile: data?.mobile,
    name: data?.firstName,
    browserId: getWebUserId(),
    query_string,
  };
};
export const removeRoute = (queryName, router) => {
  const params = new URLSearchParams(window.location.search);
  params.delete(queryName);
  if (window?.history?.length > 2) {
    router.back();
  } else {
    router.replace(
      window.location.pathname.toString() + '?' + params,
      undefined,
      { scroll: false },
    );
  }
};
export const expertFeedParams = (expertId) => {
  return {
    user_id: expertId,
    type: expertId,
    page: 1,
    isExpert: true,
    language: 0,
  };
};

export function ClickEffectCover() {
  const router = useRouter();
  const clickEffect = (setCardEffect, event, route) => {
    event.preventDefault();
    setCardEffect('lowOpacity');
    if (route) {
      setTimeout(() => {
        router.push(route + getSearchParams(), '', {
          locale: getRouterLocale(router),
        });
      }, [200]);
    }
  };
  return { clickEffect };
}

export const setItemsInCookies = (clinicId, questionData) => {
  let formSubmitArray = Cookies.get('formSubmitted')
    ? JSON.parse(Cookies.get('formSubmitted'))
    : [];
  const obj = {
    id: clinicId,
    data: questionData?.questions,
  };
  formSubmitArray.push(obj);
  let inOneDay = new Date(new Date().getTime() + 24 * 60 * 60 * 1000);
  Cookies.set(
    'formSubmitted',
    JSON.stringify(formSubmitArray),

    { expires: inOneDay },
  );
};
